<template>
  <a-modal
    v-model:visible="isVisible"
    :title="title"
    :closable="!loading"
    :maskClosable="!loading"
    centered
  >
    <a-spin :spinning="loading">
      <a-typography-title :level="5" style="margin-top: -15px">
        {{ message }}
      </a-typography-title>
      <a-typography-text v-if="helpText">
        {{ helpText }}
      </a-typography-text>
    </a-spin>
    <template #footer>
      <a-button :loading="loading" key="back" @click="handleCancel">
        {{ cancelText }}
      </a-button>
      <a-button
        :loading="loading"
        key="submit"
        :danger="danger"
        type="primary"
        :disabled="loading"
        @click="handleConfirm"
      >
        {{ confirmText }}
      </a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { computed, defineProps, defineEmits } from 'vue';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Confirmar acción'
  },
  message: {
    type: String,
    default: '¿Estás seguro de realizar esta acción?'
  },
  helpText: {
    type: String,
    default: ''
  },
  confirmText: {
    type: String,
    default: 'Confirmar'
  },
  cancelText: {
    type: String,
    default: 'Cancelar'
  },
  danger: {
    type: Boolean,
    default: false
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:visible', 'confirm', 'cancel']);

const isVisible = computed({
  get: () => props.visible,
  set: (value) => emit('update:visible', value)
});

const handleCancel = () => {
  emit('update:visible', false);
  emit('cancel');
};

const handleConfirm = () => {
  emit('confirm');
};
</script>
